module.exports = __webpack_public_path__ + "assets/img/jq_2.c9a8b4cb.png";